const segments = [
  'Menswear',
  'Womenswear',
  'Sportswear',
  'Accessories',
  'Kidswear',
  'Sustainable',
  'Bodywear',
  'Swimwear',
  'Footwear',
  'Bags',
  'Jewelry',
  'Eyewear',
];

export default segments;
